import styled from 'styled-components'

const Wrapper = styled.section`
  margin-top: 2rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  .btn-and-drop-down-container {
    width: 100%;
    max-width: 500px;
  }

  .btn-container {
    background: var(--primary-100);
    border-radius: var(--borderRadius);
    width: 100%;
    display: grid;
    justify-content: space-between;
    grid-template-columns: auto auto auto auto auto auto;
  }

  .dropDownBtn {
    background: var(--primary-100);
    border-radius: var(--borderRadius);
    width: 100%;
    color: var(--primary-500);
    border: none;
    cursor: pointer;
  }

  .dropDownBtn: hover{
    background: var(--primary-500);
    color: var(--white);
  }

  .pageBtn {
    background: transparent;
    border-color: transparent;
    height: 40px;
    font-weight: 700;
    font-size: 1.1rem;
    color: var(--primary-500);
    transition: var(--transition);
    border-radius: var(--borderRadius);
    cursor: pointer;
  }

  .pageBtn: hover{
    background: var(--primary-500);
    color: var(--white);
  }

  .active {
    background: var(--primary-500);
    color: var(--white);
  }
`
export default Wrapper
